import { render, staticRenderFns } from "./integrations-two-legged-call-api.vue?vue&type=template&id=67a9b57c"
import script from "./integrations-two-legged-call-api.vue?vue&type=script&lang=js"
export * from "./integrations-two-legged-call-api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports